import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import styles from "../../../styles/Participant-GPRA.module.css"
import FormLabel from "../Common/FormLabel"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { useState } from "react"
import FormError from "../Common/FormError"
import { Chips } from "primereact/chips"
import { InputSwitch } from "primereact/inputswitch"
import { errorMessages } from "../types/messages"
import { convertAdditionalQuestionsToText, existsErrors } from "../utils/utils"
import { useEffect, useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { INTERVIEW_SECTIONS, SECTIONS } from "../types/interviewTypes"
import Conditional from "./Conditional"

const AddAdditionalQuestion = ({
  showAddAdditional,
  setShowAddAdditional,
  disabled,
  additionalEditing,
  organizations,
  setOrganizationError,
  organizationError,
  interviewType,
  section,
  number,
  selectedOrganizations,
  setCustomizationChanges,
  groups,
  questions,
  changeAdditionalPosition,
  updateQuestions,
  matrices,
}) => {
  const [additionalModified, setAdditionalModified] = useState({
    title: "",
    options: [],
    description: "",
    type: "",
    enabled: true,
    required: true,
    subSection: "",
    id: 0,
    number: 0,
    oldTitle: "",
    groupId: undefined,
    groupOrder: undefined,
    editing: false,
    conditionalSource: undefined,
    conditionalType: "",
    conditionalValue: "",
    conditionalDisplay: false,
    conditionalRequired: false,
  })
  const [saving, setSaving] = useState()
  const [validationErrors, setValidationErrors] = useState({})
  const userCtx = useContext(UserContext)

  useEffect(() => {
    if (additionalEditing) {
      setAdditionalModified(additionalEditing)
    }
  }, [additionalEditing])

  const renderFooter = () => {
    return (
      <>
        <div>
          <Button
            disabled={disabled}
            label="Cancel"
            icon="pi pi-times"
            onClick={() => {
              setShowAddAdditional(false)
              clearValues()
            }}
            className="p-button-text"
          />
          <Button
            disabled={disabled}
            label="Save"
            icon={
              saving && Object.entries(validationErrors)?.length === 0
                ? "pi pi-spin pi-spinner"
                : "pi pi-save"
            }
            onClick={() => {
              if (organizations && organizations?.length > 0) {
                saveAdditionalQuestion()
              } else {
                setOrganizationError(true)
              }
            }}
            autoFocus
          />
        </div>
        {organizationError && (
          <div style={{ marginTop: "1rem" }}>
            <label style={{ color: "red" }}>
              Must select at least one Organization
            </label>
          </div>
        )}
      </>
    )
  }
  const validationForm = () => {
    let errors = {}
    if (!additionalModified.title) {
      errors.title = errorMessages.requiredMessage
    }
    if (additionalModified.id === 0 || !additionalModified.id) {
      if (additionalModified.title !== additionalModified.oldTitle) {
        if (
          questions?.additionalQuestions
            .filter((q) => q.section === section && q.form === interviewType)
            .some((q) => q.title === additionalModified.title && !q.deleted)
        ) {
          errors.title = "This title it's already in use"
        }
      }
    } else {
      if (
        additionalModified.title !== additionalModified.additionalOldTitle &&
        questions?.additionalQuestions.find(
          (q) => q.id === additionalModified.id
        )?.title !== additionalModified.title &&
        questions?.additionalQuestions
          .filter((q) => q.section === section && q.form === interviewType)
          .some((q) => q.title === additionalModified.title && !q.deleted)
      ) {
        errors.title = "This title it's already in use"
      }
    }
    if (!additionalModified.description) {
      errors.description = errorMessages.requiredMessage
    }
    if (!additionalModified.type) {
      errors.type = errorMessages.requiredMessage
    } else if (
      additionalModified.type === "Dropdown" ||
      additionalModified.type === "Multiselect"
    ) {
      if (additionalModified.options?.length === 0) {
        errors.options = errorMessages.requiredMessage
      }
    }
    if (additionalModified.conditionalSource) {
      if (!additionalModified.conditionalType) {
        errors.conditionalType = errorMessages.requiredMessage
      }
      if (!additionalModified.conditionalValue) {
        errors.conditionalValue = errorMessages.requiredMessage
      }
    }
    setValidationErrors(errors)
    return existsErrors(errors)
  }
  const clearValues = () => {
    setAdditionalModified({
      title: "",
      description: "",
      type: "",
      enabled: true,
      required: true,
      options: [],
      id: 0,
      oldTitle: "",
      groupId: undefined,
      groupOrder: undefined,
      conditionalSource: "",
      conditionalType: "",
      conditionalValue: "",
      conditionalDisplay: false,
      conditionalRequired: false,
    })
    setValidationErrors({})
  }
  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }
  const getTypes = () => {
    return [
      { label: "Dropdown", value: "Dropdown" },
      { label: "Multiselect", value: "Multiselect" },
      { label: "Text", value: "Text" },
      { label: "Number", value: "Number" },
      { label: "Date", value: "Date" },
    ]
  }
  const getNumber = () => {
    if (section === INTERVIEW_SECTIONS.SUBSTANCE_USE_2) {
      return number + 1
    }
    if (section === INTERVIEW_SECTIONS.SUBSTANCE_USE_3) {
      return number + 5
    }
    if (section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_5) {
      return number + 1
    }

    return number
  }

  const getGroupOrder = () => {
    const groupOrder = 1
    if (additionalModified.groupId !== undefined) {
      const selectedGroupAdditionals = groups
        ?.find((g) => g.title === additionalModified.groupId)
        ?.additionalQuestions?.filter(
          (a) => a.section === section && a.form === interviewType
        )
      if (selectedGroupAdditionals) {
        return selectedGroupAdditionals.length + 1
      }
    } else {
      return getNumber()
    }
    return groupOrder
  }
  const saveAdditionalQuestion = () => {
    setSaving(true)
    if (validationForm()) {
      let newSave = []
      if (additionalModified.editing) {
        newSave = questions?.additionalQuestions?.map((q) => {
          let newValue = { ...q }
          if (
            newValue.title === additionalModified.oldTitle &&
            q.section === section &&
            q.form === interviewType
          ) {
            newValue.number =
              !additionalModified?.groupId && additionalModified.grouped
                ? getNumber()
                : additionalModified.number
            newValue.enabled = additionalModified.enabled
            newValue.description = additionalModified.description
            newValue.oldTitle = additionalModified.oldTitle
            newValue.options = Array.isArray(additionalModified.options)
              ? convertAdditionalQuestionsToText(additionalModified.options)
              : additionalModified.options
            newValue.required = additionalModified.required
            newValue.title = additionalModified.title
            newValue.type = additionalModified.type
            newValue.questionGroup = groups?.find(
              (g) => g.title === additionalModified.groupId
            )
            newValue.groupOrder = !additionalModified.groupOrder
              ? getGroupOrder()
              : additionalModified.groupOrder
            newValue.conditionalSource = additionalModified.conditionalSource
            newValue.conditionalType = additionalModified.conditionalType
            newValue.conditionalValue = additionalModified.conditionalValue
            newValue.conditionalRequired =
              additionalModified.conditionalRequired
            newValue.conditionalDisplay = additionalModified.conditionalDisplay
          }
          return newValue
        })
      } else {
        const newAdditional = {
          id: additionalModified.id,
          organizationUuid: userCtx.session.user.organization_id,
          form: interviewType,
          section: section,
          subSection: additionalModified.subSection,
          title: additionalModified.title,
          oldTitle: additionalModified.oldTitle,
          description: additionalModified.description,
          type: additionalModified.type,
          options: convertAdditionalQuestionsToText(additionalModified.options),
          enabled: additionalModified.enabled,
          required: additionalModified.required,
          number: getNumber(),
          organizations: organizations,
          selectedOrganizations: selectedOrganizations,
          questionGroup: groups?.find(
            (g) => g.title === additionalModified.groupId
          ),
          groupOrder: getGroupOrder(),
          deleted: false,
          conditionalSource: additionalModified.conditionalSource,
          conditionalType: additionalModified.conditionalType,
          conditionalValue: additionalModified.conditionalValue,
          conditionalRequired: additionalModified.conditionalRequired,
          conditionalDisplay: additionalModified.conditionalDisplay,
        }
        newSave = [...questions?.additionalQuestions, newAdditional]
      }
      if (additionalModified.groupId) {
        const updatedGroups = questions.groups?.map((m) => {
          const additionals = newSave?.filter(
            (d) => d?.questionGroup?.title === m.title
          )
          let newValue = { ...m }
          if (additionals?.length > 0) {
            newValue.additionalQuestions = additionals
          }
          return newValue
        })
        const updateAdditionalNumberGroups = updatedGroups?.map((g) => {
          let newGroup = { ...g }
          const additionalNumbersUpdated = newGroup.additionalQuestions
            ?.filter((a) => a.section === section && a.form === interviewType)
            ?.map((a, index) => {
              return { ...a, groupOrder: index + 1, number: index + 1 }
            })
          newGroup.additionalQuestions = additionalNumbersUpdated
          return newGroup
        })
        changeAdditionalPosition(
          {
            ...questions,
            additionalQuestions: newSave,
            groups: updateAdditionalNumberGroups,
          },
          additionalModified.title,
          additionalModified.groupId !== undefined ? false : true
        )
      } else {
        const group = questions?.groups?.find(
          (g) => g.title === additionalEditing.groupId
        )
        const additionalsFiltered = group?.additionalQuestions
          ?.filter((a) => a.title !== additionalModified.oldTitle)
          .map((a, index) => {
            return { ...a, groupOrder: index + 1 }
          })
        const groupUpdated = questions?.groups?.map((g) => {
          let newValue = { ...g }
          if (newValue.title === group?.title) {
            newValue.additionalQuestions = additionalsFiltered
          }
          return newValue
        })
        const additionalsUpdated = newSave?.map((m) => {
          let newValue = { ...m }
          const newNumber = additionalsFiltered?.find(
            (n) => n.title === m.title
          )
          if (newNumber) {
            newValue.groupOrder = newNumber.groupOrder
          }
          return newValue
        })

        updateQuestions({
          ...questions,
          additionalQuestions: additionalsUpdated,
          groups: groupUpdated,
        })
      }

      setCustomizationChanges(true)
      setSaving(false)
      clearValues()
      setShowAddAdditional(false)
    }
  }
  const getGroups = () => {
    return groups?.map((group) => {
      return { label: group.title, value: group.title }
    })
  }
  return (
    <Dialog
      header={`${
        additionalModified.editing ? "Edit" : "Add"
      } additional question`}
      visible={showAddAdditional}
      onHide={() => setShowAddAdditional(false)}
      breakpoints={{ "960px": "40vw" }}
      style={{ width: "35vw" }}
      footer={renderFooter()}
      closable={false}
      blockScroll={true}
    >
      <div className={styles.formRow}>
        <FormLabel label={"Form"} />
        <InputText
          value={interviewType}
          disabled
          className={styles.inputText7}
        />
      </div>
      <div className={styles.formRow}>
        <FormLabel label={"Section"} />
        <Dropdown
          value={section}
          optionLabel="label"
          optionValue="value"
          disabled
          options={SECTIONS}
          className={
            validationErrors?.section ? styles.input7Error : styles.input7
          }
        />
      </div>
      <div className={styles.formRow}>
        <FormLabel label={"Title"} />
        <InputText
          value={additionalModified?.title}
          onChange={(e) => {
            setAdditionalModified({
              ...additionalModified,
              title: e.target.value,
            })
            removeError("title")
          }}
          className={
            validationErrors?.title ? styles.inputText7Error : styles.inputText7
          }
        />
        <FormError error={validationErrors?.title} errorType={2} />
      </div>
      <div className={styles.formRow}>
        <FormLabel label={"Description"} />
        <InputText
          value={additionalModified?.description}
          onChange={(e) => {
            setAdditionalModified({
              ...additionalModified,
              description: e.target.value,
            })
            removeError("description")
          }}
          className={
            validationErrors?.description
              ? styles.inputText7Error
              : styles.inputText7
          }
        />
        <FormError error={validationErrors?.description} errorType={2} />
      </div>
      <div className={styles.formRow}>
        <FormLabel label={"Group"} />
        <Dropdown
          value={additionalModified?.groupId}
          optionLabel="label"
          optionValue="value"
          options={getGroups()}
          showClear
          className={
            validationErrors?.title ? styles.inputText7Error : styles.inputText7
          }
          onChange={(e) => {
            setAdditionalModified({
              ...additionalModified,
              groupId: e.value,
            })
            removeError("group")
          }}
        />
        <FormError error={validationErrors?.groupId} errorType={2} />
      </div>
      <div className={styles.formRow}>
        <FormLabel label={"Type"} />
        <Dropdown
          value={additionalModified?.type}
          onChange={(e) => {
            removeError("type")
            setAdditionalModified({
              ...additionalModified,
              type: e.value,
            })
            if (e.value !== "Dropdown" && e.value !== "Multiselect") {
              setAdditionalModified({
                ...additionalModified,
                options: [],
                type: e.value,
              })
            }
          }}
          className={
            validationErrors?.type ? styles.input7Error : styles.input7
          }
          options={getTypes()}
          optionLabel="label"
          optionValue="value"
        />
        <FormError error={validationErrors?.type} errorType={2} />
      </div>
      {(additionalModified?.type === "Dropdown" ||
        additionalModified?.type === "Multiselect") && (
        <>
          <div className={styles.formRow}>
            <FormLabel label={"Options"} />
            <Chips
              value={additionalModified?.options}
              onChange={(e) => {
                removeError("options")
                setAdditionalModified({
                  ...additionalModified,
                  options: e.value,
                })
              }}
              className={
                validationErrors?.options ? styles.chipsError : styles.chips
              }
            />
            <FormError error={validationErrors?.options} errorType={2} />
          </div>
          <span
            style={{
              marginLeft: "1rem",
              width: "20rem",
              fontSize: "smaller",
              color: "grey",
            }}
          >
            Type your answer options and press enter after each option to create
            the next.
          </span>
        </>
      )}
      <div
        className={styles.formRow}
        style={{ marginTop: "1rem", marginLeft: "1rem" }}
      >
        <label className={styles.mr1} htmlFor="binary">
          Enabled{" "}
        </label>
        <InputSwitch
          style={{ verticalAlign: "text-top", marginLeft: "7rem" }}
          checked={additionalModified?.enabled}
          onChange={(e) => {
            setAdditionalModified({
              ...additionalModified,
              enabled: e.value,
            })
          }}
        />
      </div>
      <div
        className={styles.formRow}
        style={{ marginTop: "1rem", marginLeft: "1rem", marginBottom: "2rem" }}
      >
        <label className={styles.mr1} htmlFor="binary">
          Required
        </label>
        <InputSwitch
          style={{ verticalAlign: "text-top", marginLeft: "7rem" }}
          checked={additionalModified?.required}
          onChange={(e) => {
            setAdditionalModified({
              ...additionalModified,
              required: e.value,
            })
            setAdditionalModified({
              ...additionalModified,
              required: e.value,
            })
          }}
        />
      </div>
      <Conditional
        question={additionalModified}
        setQuestion={setAdditionalModified}
        removeError={removeError}
        questions={questions}
        validationErrors={validationErrors}
        section={section}
        interviewType={interviewType}
        disabled={additionalModified?.required}
        groups={groups}
        matrices={matrices}
      />
    </Dialog>
  )
}
export default AddAdditionalQuestion
